import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ItemsCategories from './Items';
import style from './style.scss';//NOSONAR

let countItem = 0;

const BannerCategories = (props) => {
    const categories = props.categories.content;
    
    if(!categories) return '';

    const getSingleImageId = (data) => {
        let id = '';
        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
            id = data.image_mobile ? data.image_mobile.split('/').pop() : '';
        } else {
            const image = data.image || data.image_desktop;
            id = image ? image.split('/').pop() : '';
        }
        return id;
    }
    
    const gtmDoubleImageId = (data, item) => {
        let id = '';
        if (typeof window !== 'undefined' && window.innerWidth <= 768) {
            const imageMobile = data[`image_${item}`][`image_mobile`];
            id = imageMobile ? imageMobile.split('/').pop() : '';
        } else {
            const imageDesktop = data[`image_${item}`][`image_desktop`];
            id = imageDesktop ? imageDesktop.split('/').pop() : '';
        }
        return id;
    }

    useEffect(() => () => countItem = 0)

    const gtmBanners = (data) => {
        return data && data.map((item) => {
            let position;
            if(item.acf_fc_layout === 'double_image'){
                for (let j = 0; j < 2; j++) {
                    const typeImage = j ? 'b' : 'a';
                    item.id = gtmDoubleImageId(item, typeImage);
                    countItem++;
                    position = countItem;
                    item.title = item.title ? item.title : item.id;
                    item[`position_${typeImage}`] = position;
                }
            } else {
                item.id = getSingleImageId(item);
                countItem++;
                position = countItem;
                item.position = 'slot' + position;
                item.title = item.title ? item.title : item.id;
            }
            return item;
        })
    }

    const leftImage = gtmBanners(categories.left_image || categories.group_left || '')
    const rightImage = gtmBanners(categories.right_image || categories.group_right || '')

    const dateServer = props.dateServer ? props.dateServer : null;

    return (
        <section className="grid-images">
            {categories.title && <h3 className="section-banner-title">{categories.title}</h3>}
            <div className="section-banner-categories">
                <div className="banner-categories-left">
                    <ItemsCategories images={leftImage} dateServer={dateServer} />
                </div>
                <div className="banner-categories-right">
                    <ItemsCategories images={rightImage} dateServer={dateServer} />
                </div>
            </div>
        </section>
    )
}

BannerCategories.propTypes = {
    categories: PropTypes.object,
    dateServer: PropTypes.number
};

export default BannerCategories;
